import { Check } from "lucide-react";
import { COMMAND_STYLES, type CommandStyleId } from "@/lib/command-styles";
import { useCommandStyle } from "@/contexts/CommandStyleContext";

const STYLE_ORDER: CommandStyleId[] = ["operator", "architect", "wave"];

export function CommandStyleSelector() {
  const { styleId, setStyle } = useCommandStyle();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      {STYLE_ORDER.map((id) => {
        const s = COMMAND_STYLES[id];
        const isSelected = styleId === id;

        return (
          <button
            key={id}
            onClick={() => setStyle(id)}
            className="relative text-left rounded-xl border-2 p-4 transition-all duration-200"
            style={{
              borderColor: isSelected ? s.colors.primary : s.colors.border,
              backgroundColor: s.colors.surface,
              boxShadow: isSelected ? `0 0 20px ${s.colors.primary}30` : "none",
            }}
          >
            {/* Check mark */}
            {isSelected && (
              <div
                className="absolute top-3 right-3 w-6 h-6 rounded-full flex items-center justify-center"
                style={{ backgroundColor: s.colors.primary }}
              >
                <Check className="h-3.5 w-3.5 text-white" />
              </div>
            )}

            {/* Style name */}
            <h3
              className="text-base font-bold tracking-tight mb-1"
              style={{ color: s.colors.textPrimary }}
            >
              {s.name}
            </h3>

            {/* Identity line */}
            <p
              className="text-xs mb-3"
              style={{ color: s.colors.textSecondary }}
            >
              {s.identity}
            </p>

            {/* Color preview dots */}
            <div className="flex items-center gap-2">
              <div
                className="w-5 h-5 rounded-full border border-white/10"
                style={{ backgroundColor: s.colors.background }}
                title="Background"
              />
              <div
                className="w-5 h-5 rounded-full border border-white/10"
                style={{ backgroundColor: s.colors.primary }}
                title="Primary"
              />
              <div
                className="w-5 h-5 rounded-full border border-white/10"
                style={{ backgroundColor: s.colors.surface }}
                title="Surface"
              />
            </div>
          </button>
        );
      })}
    </div>
  );
}
